import useMedia from '@/hooks/useMedia'
import classnames from 'classnames/bind'

// Libs

// Components

// Contexts

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface DataItemProps {
  className?: string
  title: string
  value: string | number
  additionalValue?: string
  tag?: any
  isTime?: boolean
  isLessThenTenMinutes?: boolean
  isFullWidth?: boolean
  isPast?: boolean
}

const DataItem = (props: DataItemProps) => {
  const { className, title, value, additionalValue, isTime, tag: Tag, isLessThenTenMinutes, isFullWidth, isPast } = props

  const { isMobile, isTablet } = useMedia()

  const isDrawerType = isMobile || isTablet

  return (
    <div className={cx('item', className, { isFullWidth, isTime })}>
      <div className={cx('item-title', { isTime })}>
        <p className={cx('item-title-text')}>{title}</p>

        {!isDrawerType && Tag && <div className={cx('item-tag')}>{Tag}</div>}
      </div>
      <div className={cx('item-value', { isTime })}>
        <p className={cx('item-value-text', { isTime, isAlert: isLessThenTenMinutes && !isPast })}>{value}</p>

        {additionalValue && <p className={cx('item-value-additional', { isTime })}>{additionalValue}</p>}
      </div>
      {isDrawerType && Tag && <div className={cx('item-tag')}>{Tag}</div>}
    </div>
  )
}

export default DataItem
